import { Paper, Typography } from '@mui/material';
import * as Sentry from '@sentry/react';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

const NotFound: React.FunctionComponent = () => {
  const location = useLocation();

  useEffect(() => {
    Sentry.captureMessage(`404 Not Found: ${location.pathname}`, 'info');
  }, [location.pathname]);

  return (
    <div
      style={{
        marginTop: '1em',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Paper
        style={{
          maxWidth: 1024,
          width: 1024,
          marginLeft: '1em',
          marginRight: '1em',
          padding: '2em',
          textAlign: 'center',
        }}
      >
        <Typography variant="h4" gutterBottom>
          Siden blev ikke fundet
        </Typography>
        <Typography variant="body1">
          Den side, du leder efter, findes ikke eller er blevet flyttet.
        </Typography>
      </Paper>
    </div>
  );
};

export default NotFound;
